import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#0A0E14]/95 backdrop-blur-2xl border-b border-white/5'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-4 md:py-5">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-2 md:space-x-3">
            <div className="w-8 h-8 md:w-9 md:h-9 bg-gradient-to-br from-green-400 to-emerald-500 rounded-lg flex items-center justify-center font-bold text-xs md:text-sm"
              style={{ boxShadow: '0 0 20px rgba(34, 197, 94, 0.2)' }}>
              M
            </div>
            <span className="text-lg md:text-xl font-bold text-white">
              MBhost
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8 lg:space-x-10">
            {['Features', 'Pricing', 'Security'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase())}
                className="text-gray-400 hover:text-white transition-colors duration-200 text-sm font-medium"
              >
                {item}
              </button>
            ))}
            <Button
              onClick={() => scrollToSection('cta')}
              className="bg-green-500 hover:bg-green-400 text-black font-semibold px-6 py-2 text-sm transition-all duration-200"
            >
              Get Started
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-400 p-2 -mr-2" 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-6 pb-6 flex flex-col space-y-4 border-t border-white/5 pt-6 animate-fade-up">
            {['Features', 'Pricing', 'Security'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase())}
                className="text-gray-400 hover:text-white transition-colors text-left font-medium py-2"
              >
                {item}
              </button>
            ))}
            <Button
              onClick={() => scrollToSection('cta')}
              className="bg-green-500 hover:bg-green-400 text-black w-full font-semibold py-3"
            >
              Get Started
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};